import React from 'react';

class Loading extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.title || '',
      text: props.text || 'Laster..'
    };
  }

  render() {
    return (
      <div>
        <h1 className="page-header">{this.state.title}</h1>
        <p>
          <i className="fa fa-spinner fa-pulse fa-fw"></i> {this.state.text}
        </p>
      </div>
    );
  }
}

export default Loading;
